import React from 'react';

/**
 * DbtMetricsCard Component
 * Displays a single metric with title, value, and optional trend
 */
const DbtMetricsCard = ({ title, value, trend, icon: Icon, className = '' }) => {
  return (
    <div className={`stats shadow ${className}`}>
      <div className="stat">
        <div className="stat-figure text-primary">
          {Icon && <Icon className="w-8 h-8" />}
        </div>
        <div className="stat-title">{title}</div>
        <div className="stat-value text-primary">{value}</div>
        {trend && <div className="stat-desc">{trend}</div>}
      </div>
    </div>
  );
};

export default DbtMetricsCard;
